// To add a new custom lexicon:
//   * The org ID must be the object root, on the same level as "29"
//   * List the organization name at the "Organization" key
//   * You only need to customize the terms relevant to your organization
//   * To see all customizable terms, see the "default.js" or Confluence'

const customLexicon = Object.freeze({
  "65": { //orgId
    organization: "Playland", //orgName
    core: "Center",
    choice: "Freewill",
    journey: "Adventure",
    level: "SuperMario",
    course: "Lesson",
    resource: "$$$$$",
    checkin: "Conversation",
    engagement: "Presence",
    section: "Slice",
    // "Activity" Terms
    activity: "Action",
    activity_course: "Action Time",
    //"Quest" Terms
    quest: "Secret Mission",
    quest_goal: "Secret Mission Goal",
    artifact: "Homework",
    artifact_assessment: "Homework Assessment",
    // "Skills" Terms
    skill: "Merit Badge",
    skills_check: "Merit Badge Check",
    focus_skill: "Focus Merit Badge",
    // "Term" Terms
    term: "Duration",
    term_report: "Duration Report",
    // "Mentor" Terms
    mentor: "Yoda",
    mentor_guidance: "Yoda Guidance",
    mentor_prep: "Yoda Prep",
    curriculum_phases_abb: {
      "5": "A",
      "6": "B",
      "7": "C",
      "8": "D",
      "11": "E",
      "13": "F",
      "14": "G"
    },
    curriculum_phases_name: {
      "5": "A-Level Course",
      "6": "B-Level Course",
      "7": "C-Level Course",
      "8": "D-Level Course",
      "11": "E-Level Course",
      "13": "F-Level Course",
      "14": "G-Level Course"
    },
    assessment_criteria_description: {
      "1": function () {
        return `Learning Goals on Playland organization may come from the ${customLexicon['65'].quest.toLowerCase()} goal, ${customLexicon['65'].artifact.toLowerCase()} description, content knowledge, skills, and any other additional goals the ${customLexicon['65'].mentor.toLowerCase()} and student have identified. Feedback on the Learning ${customLexicon['65'].skill}s should be provided through the ${customLexicon['65'].skills_check}.`
      },
      "5": function () {
        return `Focus organization on relevant information and tasks without getting easily distracted, shift tasks effectively, and take mental and physical breaks when needed and appropriate.`
      },
      "6": function () {
        return `Plan to complete ${customLexicon['65'].activity.toLowerCase()}s, ${customLexicon['65'].artifact.toLowerCase()}s, and projects, identifying actions, steps, and sequences of events. Identify realistic deadlines and prioritize tasks. Manage time effectively in order to meet deadlines. Keep track of tasks and deadlines using a calendar, planner, and/or other tools.`
      },
      "7": function () {
        return `Put effort into the work you do. Take initiative, make your work your own, and work hard to achieve goals. Create something you’re proud of, but also identify when it is time to move on even if ${customLexicon['65'].artifact.toLowerCase()}s and other work products do not feel perfect.`
      },
      "8": function () {
        return `Effectively take notes to keep track of ideas and information and use tools to organize and remember ideas (e.g., annotations, mindmapping).`
      }
    },
    assessment_criteria_question: {
      "1": function () {
        return `${customLexicon['65'].artifact} exhibits the skills and knowledge identified as the learning goals.`
      },
      "5": function () {
        return `${customLexicon['65'].artifact} reflects attention to details and the focus needed to complete it.`
      },
      "6": function () {
        return `${customLexicon['65'].artifact} shows evidence of effective planning and time management given the task at hand.`
      },
      "7": function () {
        return `${customLexicon['65'].artifact} effort is demonstrated for the type and size of the ${customLexicon['65'].artifact.toLowerCase()}.`
      },
      "8": function () {
        return `${customLexicon['65'].artifact} is created using effective notes and documentation and work is shown where appropriate.`
      }
    }
  },
  "190": {
    organization: "Mater Academy Narcoossee",
    mentor: "Teacher"
  },
  "88": {
    organization: "Girard College High School",
    mentor: "Teacher",
    mentor_guidance: "Teacher Guidance",
    mentor_prep: "Teacher Prep",
  },
})

export default customLexicon
